/**
 * CheckBox modules
 */
export * from './check-box';



//////////////////
// WEBPACK FOOTER
// ./node_modules/@syncfusion/ej2-buttons/src/check-box/index.js
// module id = 1844
// module chunks = 0